import { DashboardState, ESdChangeReason } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { withHistory } from "../../../../shared/hoc/with-history";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTooltip from "../../../ui-kit/kuika-tooltip/kuika-tooltip";

declare let window: any;

export interface IIsometricToggleState {
  isFreePositionAreaEnabled: boolean;
}

export interface IIsometricToggleProps {}

class IsometricToggle extends PureSdComponent<
  IIsometricToggleProps & IWithSDProps & IWithContextProp,
  IIsometricToggleState
> {
  constructor(props: IIsometricToggleProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {
      isFreePositionAreaEnabled: false
    };
  }

  componentDidMount() {
    const storedValue = localStorage.getItem("isFreePositionAreaEnabled");
    let initialValue = false;

    if (storedValue !== null) {
      initialValue = storedValue === "true";
    }

    this.setState({ isFreePositionAreaEnabled: initialValue });
  }

  toggleIsometric = () => {
    const newValue = !this.state.isFreePositionAreaEnabled;

    this.setState({ isFreePositionAreaEnabled: newValue });

    localStorage.setItem("isFreePositionAreaEnabled", newValue.toString());

    // Dispatch custom event to notify other components
    window.dispatchEvent(
      new CustomEvent("isFreePositionAreaChanged", {
        detail: { isFreePositionAreaEnabled: newValue }
      })
    );
  };

  render() {
    if (
      this.props.sd.dashboardState !== DashboardState.design &&
      this.props.sd.dashboardState !== DashboardState.reportDesigner
    ) {
      return null;
    }

    const { isFreePositionAreaEnabled } = this.state;
    const tooltipTitle = isFreePositionAreaEnabled ? "Free Position" : "Isometric Grid";

    return (
      <KuikaTooltip content={tooltipTitle} position="bottom">
        <KuikaButton
          onClick={this.toggleIsometric}
          active={!isFreePositionAreaEnabled}
          size="sm"
          type="tertiary"
          color="neutral"
          isIcon
        >
          <KuikaSvg name="grid-dots" width={16} height={16} />
        </KuikaButton>
      </KuikaTooltip>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const isometricToggle = withContext<IIsometricToggleProps>(
  withSD<IIsometricToggleProps>(withHistory<IIsometricToggleProps>(IsometricToggle))
);

export { isometricToggle as IsometricToggle };
